import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GetQueryParam, isLogged } from '../../utils/common';
import { useDispatch } from 'react-redux';
import { SkeltonCardTwo } from '../../common/SkeltonCardTwo';
import { isMobileView } from '../../utils/utils';
import { Skeleton } from '@mui/material';
import ButtonScogoPrimary from '../../common/Buttons/ButtonScogoPrimary';
import { getSupportTrackTicketDetails } from '../../actions/service_request';
import Details from './Details';
import { Chats } from './Chat';
import { useNavigate } from 'react-router-dom';
import { trackSupportTicket } from '../../router/roleWisePageRoute';


export const futopiaCustomerId = 3706;
export const defaultDevProject = 118;

export default function SupportTrack() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const supportTrackServiceRequestError = useSelector((state) => state.serviceRequest.supportTrackServiceRequestError);
    const isSupportTrackServiceRequestLoading = useSelector((state) => state.loading.isSupportTrackServiceRequestLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const ticketId = GetQueryParam('ticketId');
    const redirectTo = GetQueryParam('redirectTo') || '';

    useEffect(() => {
        document.title = "Support";
    }, []);

    useEffect(() => {
        if (ticketId) {
            dispatch(getSupportTrackTicketDetails({ ticketId }));
        }
    }, [ticketId, dispatch]);

    useEffect(() => {
        if ((isLogged() && newLoggedUserData) && redirectTo !== 'detail' && redirectTo !== 'chat') {
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('redirectTo', 'chat');
            navigate(`${trackSupportTicket.path}?${currentParams.toString()}`, { replace: true });
        }
    }, [redirectTo, newLoggedUserData, navigate]);

    if (ticketId && !isSupportTrackServiceRequestLoading && supportTrackServiceRequestError) {
        return (
            <div className='subContainer h-full bg-white'>
                <NoResultFoundUI message='Ticket details not found.' />
            </div>
        );
    }

    if (isSupportTrackServiceRequestLoading) {
        return (
            <div className='px-6'>
                <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8, 9]} height={20} className={'my-4'} />
            </div>
        );
    }

    if (redirectTo === 'chat' && isLogged() && Object.keys(newLoggedUserData).length > 0) {
        return <Chats />;
    }

    return <Details ticketId={ticketId} />;
}

const NoResultFoundUI = ({ message }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full bg-gray-50 p-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">{message || 'No results found'}</h2>
            <p className="text-gray-500 text-center max-w-xs">
                Please check the ticket ID or try refreshing the page. If the problem persists, contact support.
            </p>
            <button
                onClick={() => window.location.reload()}
                className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
                Refresh
            </button>
        </div>
    );
};